import queryString from 'query-string';
import { Dialog } from '@sdi/fish';
import moment from 'moment';
import {
  baseUrl,
  linkBaseUrl,
} from '@/common/config.js';
import {
  isWxAli, merchantInfoId,
} from '@/common/common';
import router from '@/routers';
// import miniProgram from '@/common/miniProgram.js';
// import VueCookies from 'vue-cookies';

const { NODE_ENV } = process.env;

// eslint-disable-next-line import/prefer-default-export
export function resizeImg(url, type = 'small', quality = '90') {
  if (!url || url.indexOf('statics.lotsmall.cn') < 0) {
    return url;
  }
  const res = queryString.parseUrl(url);
  if (!res) {
    return url;
  }
  let size = type.trim();
  if (size[size.length - 1] !== 'x') {
    switch (size) {
      case 'tiny':
        size = '50x';
        break;
      case 'big':
        size = '750x';
        break;
      case 'middle':
        size = '300x';
        break;
      case 'small':
      default:
        size = '100x';
        break;
    }
  }
  if (res.query) {
    let query;
    if (canUseWebP()) {
      query = `imageMogr2/thumbnail/${size}/strip/quality/${quality}/format/webp`;
    } else {
      query = `imageMogr2/thumbnail/${size}/strip/quality/${quality}`;
    }
    res.query[query] = null;
    return queryString.stringifyUrl(res);
  }
  return url;
}

let isSupportWebP = null;
export function canUseWebP() {
  if (isSupportWebP !== null) {
    return isSupportWebP;
  }
  const elem = document.createElement('canvas');

  if (elem.getContext && elem.getContext('2d')) {
    isSupportWebP = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  } else {
    isSupportWebP = false;
  }

  return isSupportWebP;
}

export function formatDay(time) {
  if (!time) {
    return '';
  }
  return moment(time).format('YYYY-MM-DD');
}

export function formatTime(time) {
  if (!time) {
    return '';
  }
  return moment(time).format('YYYY-MM-DD HH:mm:ss');
}

export function formatHour(time) {
  if (!time) {
    return '';
  }
  return moment(time).format('HH:mm');
}

/**
 * 姓名格式校验
 * @param {string} val 姓名
 */
export function checkName(val) {
  let name = val;
  if (typeof val === 'string') {
    name = val.trim();
  }
  return name && (/^([a-zA-Z\u4e00-\u9fa5\s]{1,200})$/.test(name));
}

/**
 * 手机号校验
 * @param {Number | String} val 值
 */
export function checkMobile(val) {
  if (!val) return false;
  return /^1[3-9][0-9]{9}$/.test(val);
}

/**
 * 邮箱校验
 * @param {String} val 值
 */
export function checkEmail(val) {
  if (!val) return false;
  // eslint-disable-next-line no-useless-escape
  return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(val);
}

export function getUrlQuery(url) {
  const index = url.indexOf('?');
  if (index === -1) return {};
  const queryList = url.substr(index + 1).split('&');
  return queryList.reduce((result, curr) => {
    const [key, value] = curr.split('=');
    return { ...result, [key]: value };
  }, {});
}

export function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
export function wxAliLogin(channl) {
  let rediurl;
  const nextPath = localStorage.getItem('xjsc_nextpath_2019_4_20');
  if (nextPath) {
    rediurl = nextPath;
    localStorage.removeItem('xjsc_nextpath_2019_4_20');
  } else {
    rediurl = window.location.href;
  }
  const params = {
    channl,
    redirectUrl: encodeURIComponent(rediurl),
    merchantInfoId,
  };
  const url =
    `${baseUrl }leaguer/api/authApi/auth?${ queryString.stringify(params)}`;
  window.location.href = url;
}

const env = isWxAli();

export function httpError(http) {
  return (response) => {
    if (response) {
      if (response.config.url === '/marketing/api/log/save' ||
          response.config.url === '/marketing/api/log/error' ||
          response.config.url.indexOf('/merchant/api/merchantInfo/getGraytatus') >= 0) {
        return false;
      }
      if (response.status === 400 || response.data.code === 1004001005) {
        // token过期、token不存在
        let channl = '';
        if (env.isWx) {
          // 微信内置浏览器
          http({
            url: '/pay/api/getPayInfo',
            method: 'get',
            params: {
              payCode: 'wxZyb',
            },
          }).then(res => {
            const wxAccount = {
              appid: '',
              appsecret: '',
            };
            if (res && res.data && res.data.details && res.data.details.length) {
              res.data.details.forEach(element => {
                if (element.payKey === 'appid') { wxAccount.appid = element.payValue; }
                if (element.payKey === 'appsecret') { wxAccount.appsecret = element.payValue; }
              });
            }
            localStorage.setItem('xjsc_vue_2019_3_19_wxAccount', JSON.stringify(wxAccount));
            channl = 'WEIXIN';
            wxAliLogin(channl);
          });
        } else if (env.isAliPay) {
          channl = 'ALI';
          wxAliLogin(channl);
        } else if (env.isYunPay) {
          channl = 'YUNSHANFU';
          wxAliLogin(channl);
        } else {
          // 其他浏览器
          router.push({
            path: `/login?m_id=${merchantInfoId}`,
          });
        }
      } else if (response.status === 410) {
        // 手机浏览器登录用户直接用手机号码登录不需要绑定手机号码，也就支付宝和微信H5用户需要
        // 410状态微信h5及支付宝h5用户登录后未绑定手机号码
        // 需要跳转手机号码绑定页面
        const rediurl = encodeURIComponent(window.location.href);
        if (NODE_ENV === 'production') {
          const url = `${linkBaseUrl }/bind/mobile?m_id=${merchantInfoId}&rediurl=${ rediurl}`;
          if (window.location.href !== url) {
            window.location.href = url;
          }
        } else {
          router.push({
            path: `/bind/mobile?rediurl=${ rediurl}`,
          });
        }
      } else {
        Dialog.alert({
          title: '提示',
          message: response.data.message || '请求失败',
        });
      }
    }
  };
}

export function dealTime(time) {
  if (!time) return;
  const _time = time.split(' ');
  const date1 = _time[0].split('-');
  const date2 = _time[1].slice(0, -3);
  const year = date1[0];
  const month = date1[1];
  const day = date1[2];
  return `${year}年${month}月${day}日 ${date2}`;
}

// 对字符串进行简单加密
export function compileStr(code) {
  let c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (let i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c);
}

// 字符串进行简单解密
export function uncompileStr(code) {
  code = unescape(code);
  let c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (let i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}
// 获取token
export function getToken() {
  // const m_id = merchantInfoId;
  // if (miniProgram.isMP()) {
  //   return VueCookies.get(`mini_token_${m_id}`);
  // } else {
  //   // return VueCookies.get('sc_token_20200216');
  //   return localStorage.getItem('sc_token_20200216');
  // }
  return localStorage.getItem('sc_token_20200216');
}
// 清除用户信息
export function clearToken() {
  localStorage.removeItem('xjsc_login_access_token_2019_3_7');
  localStorage.removeItem('xjsc_login_userId_2019_3_8');
  localStorage.setItem('token_type', '');
  // 清除旧的token和leaguerInfoId
  const keys = this.$cookies.keys();
  keys && keys.forEach(item => {
    if (item.includes('token') || item.includes('leaguerInfoId')) {
      this.$cookies.remove(item, null, window.location.hostname);
    }
  });
}

// 地图转换
export const coordTransform = {
  PI: 3.14159265358979324,
  x_pi: 3.14159265358979324 * 3000.0 / 180.0,

  // WGS84转GCJ02(火星坐标)
  wgs84togcj02(lng, lat) {
    if (this.outOfChina(lng, lat)) {
      return [lng, lat];
    }

    let dlat = this.transformLat(lng - 105.0, lat - 35.0);
    let dlng = this.transformLng(lng - 105.0, lat - 35.0);

    const radlat = lat / 180.0 * this.PI;
    let magic = Math.sin(radlat);
    magic = 1 - 0.00669342162296594323 * magic * magic;
    const sqrtmagic = Math.sqrt(magic);

    dlat = (dlat * 180.0) / ((6378245.0 * (1 - 0.00669342162296594323)) / (magic * sqrtmagic) * this.PI);
    dlng = (dlng * 180.0) / (6378245.0 / sqrtmagic * Math.cos(radlat) * this.PI);

    const mglat = lat + dlat;
    const mglng = lng + dlng;

    return [mglng, mglat];
  },

  // GCJ02转百度坐标
  gcj02tobd09(lng, lat) {
    const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * this.x_pi);
    const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * this.x_pi);
    const bd_lng = z * Math.cos(theta) + 0.0065;
    const bd_lat = z * Math.sin(theta) + 0.006;
    return [bd_lng, bd_lat];
  },

  // WGS84转百度坐标
  wgs84tobd09(lng, lat) {
    const gcj = this.wgs84togcj02(lng, lat);
    return this.gcj02tobd09(gcj[0], gcj[1]);
  },

  // 判断坐标是否在中国境内
  outOfChina(lng, lat) {
    return (lng < 72.004 || lng > 137.8347) || (lat < 0.8293 || lat > 55.8271);
  },

  transformLat(lng, lat) {
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * this.PI) + 20.0 * Math.sin(2.0 * lng * this.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * this.PI) + 40.0 * Math.sin(lat / 3.0 * this.PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lat / 12.0 * this.PI) + 320 * Math.sin(lat * this.PI / 30.0)) * 2.0 / 3.0;
    return ret;
  },

  transformLng(lng, lat) {
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * this.PI) + 20.0 * Math.sin(2.0 * lng * this.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lng * this.PI) + 40.0 * Math.sin(lng / 3.0 * this.PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lng / 12.0 * this.PI) + 300.0 * Math.sin(lng / 30.0 * this.PI)) * 2.0 / 3.0;
    return ret;
  },
};
